import { DATA_HOOKS } from './Header.constants';

const headerDriverFactory = ({ element }) => {
  const title = () =>
    element.querySelector(`[data-hook="${DATA_HOOKS.title}"]`);
  const subtitle = () =>
    element.querySelector(`[data-hook="${DATA_HOOKS.subtitle}"]`);

  return {
    exists: () => !!element,
    title: () => {
      const el = title();
      return el && el.textContent;
    },
    subtitle: () => {
      const el = subtitle();
      return el && el.textContent;
    },
  };
};

export default headerDriverFactory;
